import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { createCategorySlug, hasPosts } from "../utils"
import { FaLongArrowAltRight } from "react-icons/fa"
import OptimizedImage from "gatsby-image/withIEPolyfill"
import { buildCategoryUrl, buildPostSlug } from "../utils/urls"

/**
 * Sidebar Component
 * This component is generating the sidebar used in news pages
 * this data is shared between category pages, news pages, single post pages
 *
 * @param {Object} props
 */
const Sidebar = () => {
  let { categories, posts } = useStaticQuery(graphql`
    {
      categories: allSanityCategory {
        edges {
          node {
            id
            title
          }
        }
      }
      posts: allSanityPost {
        edges {
          node {
            id
            title
            slug {
              current
            }
            mainImage {
              asset {
                _id
                url
                fluid(maxHeight: 95) {
                  ...GatsbySanityImageFluid_withWebp
                }
              }
            }
            categories {
              id
            }
          }
        }
      }
    }
  `)

  posts = ((posts || {}).edges || []).map(node => node.node)

  categories = (categories || {}).edges || []
  categories = categories
    .map(node => node.node)
    .filter(category => {
      return hasPosts(category.id, posts)
    })

  const featuredPosts = posts.slice(0, 3)

  return (
    <div className="sidebar">
      <h4 className="sidebar-title">Categories</h4>

      <div className="sidebar-links">
        {categories.map(({ title }, index) => {
          return (
            <Link
              key={index}
              className="sidebar-links__link"
              to={buildCategoryUrl(createCategorySlug(title))}
            >
              <FaLongArrowAltRight className="sidebar-link__icon" />
              {title}
            </Link>
          )
        })}
      </div>

      <h4 className="sidebar-title">Success stories</h4>

      {featuredPosts.map(post => (
        <Link
          className="sidebar-post"
          key={post.id}
          to={buildPostSlug(post.slug.current)}
        >
          <OptimizedImage
            className="sidebar-post__image"
            fluid={post.mainImage.asset.fluid}
            alt={post.title}
            fadeIn={true}
            objectFit="cover"
            objectPosition="50% 50%"
          />
          <h3 className="sidebar-post__title">{post.title}</h3>
        </Link>
      ))}

      <div className="sidebar-cta">
        <h3 className="sidebar-cta__title">
          At Opklim, We Always Put Our Clients First
        </h3>
        <p className="sidebar-cta__text">
          Sit amet consectetur adipisicing elit eor incididuynt uet labore.
        </p>
        <Link className="btn btn-white">
          Get in touch <FaLongArrowAltRight />
        </Link>
      </div>
    </div>
  )
}

export default Sidebar
